import { addDays } from '~/shared/lib/clubClock';

export const toLocalIsoDate = (d: Date): string => {
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
};

const offsetFromMonday = (day: string): number => (new Date(`${day}T00:00:00Z`).getUTCDay() + 6) % 7;

export const weekRange = (iso: string): { start: string; end: string; days: string[] } => {
  const start = addDays(iso, -offsetFromMonday(iso));
  const days = Array.from({ length: 7 }, (_, i) => addDays(start, i));
  return { start, end: days[6]!, days };
};

export const monthRange = (
  iso: string,
): { firstOfMonth: string; days: string[]; gridStart: string; gridEnd: string } => {
  const firstOfMonth = `${iso.slice(0, 7)}-01`;
  const gridStart = addDays(firstOfMonth, -offsetFromMonday(firstOfMonth));
  const days = Array.from({ length: 42 }, (_, i) => addDays(gridStart, i));
  return { firstOfMonth, days, gridStart, gridEnd: days[41]! };
};
